import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";
import { firebaseConfig as devConfig } from "./firebase.config.dev";
import { firebaseConfig as prodConfig } from "./firebase.config.prod";

// Environment Detection
// - Development: npm run build (--mode development) uses pupzik
// - Production: npm run build:prod (--mode production) uses vinividi
// Vite's MODE is set via the --mode flag in package.json scripts
const isDevelopment = import.meta.env.MODE === 'development';
const firebaseConfig = isDevelopment ? devConfig : prodConfig;

// Log which environment is being used (helpful for debugging)
console.log(`🔥 Project ID: ${firebaseConfig.projectId}`);

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase services for use in other parts of the app
export const auth = getAuth(app);

// Initialize Firestore with offline persistence enabled
// Using the new cache configuration API (replaces deprecated enableIndexedDbPersistence)
export const db = getFirestore(app);

export const functions = getFunctions(app);
export const storage = getStorage(app);
